import React, { memo, useEffect, useState } from "react";
import loadable from "@loadable/component";
import clsx from "clsx";
import isEmpty from "lodash/isEmpty";

import styles from "./AnchorMenu.styles";

const Container = loadable(() => import("@Components/views/Container"));
const ReactLink = loadable(() => import("@micado-digital/react-link/ReactLink"));
const Typography = loadable(() => import("@micado-digital/react-ui/components/Typography"));

const AnchorMenu = ({ items = [], show }) => {
	const [animate, setAnimate] = useState(false);
	const css = styles();

	useEffect(() => {
		setAnimate(show);
	}, [show]);

	if (isEmpty(items)) return <></>;

	return (
		<div
			className={clsx(css.anchorMenu, "mco-view-component-anchor-menu", {
				[css.animate]: animate
			})}
		>
			<Container className={clsx(css.container, "mco-view-component-anchor-menu__container")}>
				{items?.map((item, index) => {
					const { tag, title } = item;

					return (
						<div
							className={clsx(css.item, "mco-view-component-anchor-menu__item")}
							key={index}
						>
							<ReactLink to={`#${tag}`}>
								<Typography
									className={clsx(css.label, "mco-view-component-anchor-menu__item-label")}
									component="span"
									dangerouslySetInnerHTML={{ __html: title }}
									variant="label-small"
								/>
							</ReactLink>
						</div>
					);
				})}
			</Container>
		</div>
	);
};

export default memo(AnchorMenu);
